/**
 * Zod validation schemas for CRM and inbox types
 * Redirects to the centralized type system in lib/crm/types
 */

import { z } from "zod";

// Re-export core schemas
export {
  ImportanceSchema,
  ProviderKeySchema,
  SenderSchema,
  RecipientSchema,
  ContactStatusSchema,
  ContactTypeSchema,
  TaskStatusSchema,
  TaskPrioritySchema,
  MeetingStatusSchema,
  ProposalStatusSchema,
  ClientStatusSchema,
} from "../types/common";

import {
  MessageBaseSchema,
  MessageSchema,
  UnifiedMessageSchema,
  MessageListResponseSchema,
  UnifiedMessageListResponseSchema,
  DateRangeSchema,
  MessageFilterSchema,
  MessageSortFieldSchema,
  MessageSortSchema,
  ProviderStatsSchema,
  MessageStatsSchema,
} from "../types/message";

export {
  MessageBaseSchema,
  MessageSchema,
  UnifiedMessageSchema,
  MessageListResponseSchema,
  UnifiedMessageListResponseSchema,
  DateRangeSchema,
  MessageFilterSchema,
  MessageSortFieldSchema,
  MessageSortSchema,
  ProviderStatsSchema,
  MessageStatsSchema,
} from "../types/message";

export { InboxSchema, InboxGroupSchema } from "../types/inbox";

// Additional schemas maintained for backward compatibility

export const UseUnifiedMessagesOptionsSchema = z.object({
  connections: z.array(
    z.object({
      provider: z.string(),
      connectionId: z.string(),
    })
  ),
  limit: z.number().int().positive().optional(),
  filter: MessageFilterSchema.optional(),
  sort: MessageSortSchema.optional(),
  enabled: z.boolean().optional(),
});

export type UseUnifiedMessagesOptions = z.infer<typeof UseUnifiedMessagesOptionsSchema>;

export const UseMessagesWithContextOptionsSchema = z.object({
  inboxId: z.string().uuid(),
  provider: z.string(),
  filter: z.string().optional(),
  limit: z.number().int().positive().optional(),
  enabled: z.boolean().optional(),
});

export type UseMessagesWithContextOptions = z.infer<typeof UseMessagesWithContextOptionsSchema>;

// ============================================================================
// VALIDATION HELPERS
// ============================================================================

export {
  validateMessage,
  validateMessageSafe,
  validateMessageFilter,
  validateMessageListResponse,
  validateInbox,
  validateInboxes,
} from "../types/index";
